import { RouteStatus, RouteStatusLabels } from '../enums';
import { VisitStatus, VisitStatusLabels } from '../enums';
import { formatDate, formatRouteScheduledCalendarDay } from './dateFormatter';

export { RouteStatusLabels, VisitStatusLabels };

export const getRouteStatusLabel = (status: RouteStatus): string => {
  return RouteStatusLabels[status] || status;
};

export const getVisitStatusLabel = (status: VisitStatus): string => {
  return VisitStatusLabels[status] || status;
};

export interface RouteStatusTextParams {
  status: RouteStatus;
  scheduled: string;
  scheduledCalendarDate?: string | null;
  updatedAt: string;
  statusLabel: string;
}

export const getRouteStatusText = ({
  status,
  scheduled,
  scheduledCalendarDate,
  updatedAt,
  statusLabel,
}: RouteStatusTextParams): string => {
  if (status === RouteStatus.IN_PROGRESS) {
    return `En curso desde el ${formatRouteScheduledCalendarDay({
      scheduled,
      scheduledCalendarDate,
    })}`;
  }
  if (status === RouteStatus.COMPLETED) {
    return `Completada desde ${formatDate(updatedAt)}`;
  }
  return statusLabel;
};

